import {
  ElectricityUpdateRecord,
  JobUpdateRecord,
  LocationDistrict,
  LocationObject,
} from '@/lib/types';

export const PUBLIC_UPDATES_DATE_FORMATTER = new Intl.DateTimeFormat('en-IN', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
});

export function parseSheetDateToISO(dateValue: string): string | null {
  const parts = dateValue.split('/');
  if (parts.length !== 3) {
    return null;
  }
  const [day, month, year] = parts;
  if (!day || !month || !year) {
    return null;
  }
  return `${year.padStart(4, '0')}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

export function formatISODateForDisplay(dateISO: string): string {
  const parsed = new Date(`${dateISO}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return dateISO;
  }
  return PUBLIC_UPDATES_DATE_FORMATTER.format(parsed);
}

export function getTodayISODate(): string {
  return new Date().toISOString().slice(0, 10);
}

export function normalizeElectricityRecord(raw: Record<string, unknown>): ElectricityUpdateRecord {
  return {
    id: String(raw._id ?? ''),
    districtCode: String(raw.Dist__Code ?? ''),
    areas: String(raw.Areas ?? ''),
    outageDate: String(raw.Date ?? ''),
    timeFrom: String(raw.From ?? ''),
    timeTo: String(raw.To ?? ''),
  };
}

export function normalizeJobRecord(raw: Record<string, unknown>): JobUpdateRecord {
  return {
    id: String(raw._id ?? ''),
    stateCode: String(raw.StateCode ?? ''),
    districtCode: String(raw.DistrictCode ?? ''),
    title: String(raw['Title-Designation'] ?? ''),
    companyName: String(raw['CompanyName-RecruitmentBoard'] ?? ''),
    lastDateForApplication: String(raw.LastDateforApplication ?? ''),
    openings: String(raw.Openings ?? ''),
    salary: String(raw['Salary-Stipend'] ?? ''),
    type: String(raw.Type ?? ''),
    totalCompanies: raw.TotalCompanies ? String(raw.TotalCompanies) : undefined,
  };
}

export function toLocationEntries<T extends LocationObject | LocationDistrict>(
  map: Record<string, T>,
): Array<{ slug: string; data: T }> {
  return Object.entries(map).map(([slug, data]) => ({ slug, data }));
}
